export interface NavItem {
  path: string;
  label: string;
  icon: string;
}

export const NAV_ITEMS: NavItem[] = [
  { path: '/aujourdhui', label: "Aujourd'hui", icon: '☀' },
  { path: '/semaine', label: 'Semaine', icon: '▦' },
  { path: '/pointage', label: 'Pointage', icon: '✓' },
  { path: '/patients', label: 'Patients', icon: '☺' },
  { path: '/rapport', label: 'Rapport', icon: '▤' },
  { path: '/reglages', label: 'Réglages', icon: '⚙' },
];
